import { Alert } from '../../../ui/feedback';
import { Timestamp } from '../../../ui/Timestamp';
import type { AttemptDetail } from '../types';
import { UnlinkedRunAlert } from '../UnlinkedRuns';

export function AttemptStatus({ a }: { a: AttemptDetail }) {
  const b = a.binding;
  return (
    <>
      {a.awaitingVerification && (
        <Alert tone="info" title="Awaiting verification">
          The Deploy run succeeded. An admin records the manual checks below; the attempt succeeds when they
          all pass, or fails when one fails.
        </Alert>
      )}
      {a.needsReport && (
        <UnlinkedRunAlert attempt={a.number} executor={a.executor?.name ?? null} runs={a.unlinkedRuns} />
      )}
      {a.state === 'deploying' && !a.awaitingVerification && !a.needsReport && (
        <Alert tone="info" title="Executing externally">
          The executor deploys outside this application and reports here. Overlapping attempts in{' '}
          {b.environmentName} are blocked.
        </Alert>
      )}
      {a.state === 'unknown' && !a.awaitingVerification && (
        <Alert tone="warning" title="Outcome unknown">
          No result was reported
          {a.unknownAt ? (
            <>
              {' '}
              (marked unknown <Timestamp value={a.unknownAt} />)
            </>
          ) : (
            ''
          )}
          . Timeout never infers success or failure. The executor or an admin must reconcile with evidence
          before the environment unlocks.
        </Alert>
      )}
      {(a.provenance === 'reported' || a.provenance === 'webhook') && a.state === 'succeeded' && (
        <Alert tone="info">
          This result was reported by {a.report?.reportedBy.name}; the application did not independently
          observe the deployment.
        </Alert>
      )}
    </>
  );
}
